import { Col, Row } from "antd";
import React from "react";
import MobHeader from "../../Components/Header/MobHeader";
import { ThemeFancyCard, ThemePara1, ThemeTitle } from "../Styles/Theme";
import {
  OptionCard,
  TealIcon,
  CardContent,
  CardTitle,
  CardDescription,
  ChevronButton,
} from "./PollingAgentStyle";
import { RightOutlined } from "@ant-design/icons";
import { Link, Navigate } from "react-router-dom";
import { usePollingAgentPermissions } from "../../utils/permissions";

// Styled components for the cards

const PollingAgents = () => {
  // Permission check - shortcut hook
  const { can } = usePollingAgentPermissions();

  // If user doesn't have create permission, redirect to list page
  if (!can('create')) {
    return <Navigate to="/polling-agents" replace />;
  }

  return (
    <>
      {/* <Header
        breadcrumb={false}
        title1="AI JDV"
        link1="/polling-agents/"
        title2="New AI JDV Agent"
      /> */}
      <MobHeader />
      <ThemeFancyCard className="flexWrapper">
        <Row gutter={[16, 16]} className="text-center mb-8">
          <Col span={24}>
            <img className="m-auto" alt="" src="/images/title-img.svg" />
          </Col>
          <Col span={24}>
            <ThemeTitle className="mb-1">Create AI JDV Agent</ThemeTitle>
            <ThemePara1>
              Choose your preferred method to begin collaborating with the
              agent.
            </ThemePara1>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col
            xs={{ span: 24, offset: 0 }}
            sm={{ span: 24, offset: 0 }}
            md={{ span: 20, offset: 1 }}
            lg={{ span: 16, offset: 4 }}
            xl={{ span: 14, offset: 5 }}
          >
            <Link to="/polling-agents/polling-agent/create-polling-agent/">
              <OptionCard>
                <TealIcon className="cyanIcon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 5V19M5 12H19"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </TealIcon>
                <CardContent>
                  <CardTitle>Start from scratch</CardTitle>
                  <CardDescription>
                    Create a custom AI JDV agent.
                  </CardDescription>
                </CardContent>
                <ChevronButton
                  size="large"
                  shape="circle"
                  icon={<RightOutlined />}
                />
              </OptionCard>
            </Link>
            <Link href="/">
              <OptionCard>
                <TealIcon className="orangeIcon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14 2V8H20"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16 13H8"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16 17H8"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10 9H9H8"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </TealIcon>
                <CardContent>
                  <CardTitle>Browse Templates</CardTitle>
                  <CardDescription>
                    Choose from our diverse range of customizable templates to
                    suit your needs.
                  </CardDescription>
                </CardContent>
                <ChevronButton
                  size="large"
                  shape="circle"
                  icon={<RightOutlined />}
                />
              </OptionCard>
            </Link>
          </Col>
        </Row>
      </ThemeFancyCard>
    </>
  );
};

export default PollingAgents;
